import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAuthStore } from '../stores/authStore';

const { FiLogOut, FiUser } = FiIcons;

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <motion.header
      className="fixed top-0 left-0 right-0 shadow-md z-50"
      style={{ backgroundColor: '#2b6777' }}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-4 text-white">
            <img 
              src="https://letcheck.b-cdn.net/944/bild-logo-final-dunkel-1726774068395.png" 
              alt="Logo" 
              className="h-12 w-auto"
            />
            <div className="flex flex-col">
              <span className="text-xl font-bold font-rubik">Entscheidungsgeschichten</span>
            </div>
          </Link>

          <nav className="flex items-center space-x-4">
            {user ? (
              <>
                <Link
                  to="/dashboard"
                  className={`px-4 py-2 rounded-lg transition-colors font-rubik ${
                    location.pathname === '/dashboard'
                      ? 'bg-white/20 text-white'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                  }`}
                >
                  Dashboard
                </Link>
                <div className="flex items-center space-x-2 text-white/80">
                  <SafeIcon icon={FiUser} className="w-4 h-4" />
                  <span className="text-sm font-rubik">{user.email}</span>
                </div>
                <button
                  onClick={handleLogout}
                  className="flex items-center space-x-1 px-4 py-2 text-white/80 hover:text-white hover:bg-white/10 transition-colors rounded-lg font-rubik"
                >
                  <SafeIcon icon={FiLogOut} className="w-4 h-4" />
                  <span>Abmelden</span>
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="px-4 py-2 rounded-lg transition-colors font-rubik text-white"
                style={{ backgroundColor: '#c8d8e4' }}
              >
                Anmelden
              </Link>
            )}
          </nav>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;